
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enter",
      function () {
        return require("private-next-pages/enter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enter"])
      });
    }
  